// Theme Layout Constants
// These values are used throughout the application for consistent spacing and sizing

export const gridSpacing = 3; // Base grid spacing unit (in pixels) for layout components
export const drawerWidth = 280; // Width of the sidebar drawer component (in pixels)

// Theme Configuration Settings
// Add additional theme-related configuration options below

// ==============================|| THEME CONSTANT  ||============================== //

// ==============================|| THEME CONFIG  ||============================== //

// Pro Version
